module.exports = __webpack_public_path__ + "static/img/yami_1.7baabdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/officeImg/index/yami_1.png
// module id = ZJaM
// module chunks = 1